import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import * as moment from 'moment';
import { Messages } from 'src/app/shared/Validations/messages';
import { UploadToVault } from 'src/app/shared/common/uploadtovaultbutton';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { SenttovaultcomponentComponent } from './senttovaultcomponent/senttovaultcomponent.component';
import {CommonDownloadLinkFromS3} from '../../shared/common/commonDownloadLinkFromS3';
import {MatSelectChange} from '@angular/material/select';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {validationmethod} from '../../shared/common/validationmethod';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-report-instance-upcoming',
    templateUrl: './report-instance-upcoming.component.html',
    styleUrls: ['./report-instance-upcoming.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class ReportInstanceUpcomingComponent implements OnInit {

  value;
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  buttonName;

  getdata: any;
  validation_messages:any;
  backgroundColorScreen = "";
  backgroundColorButton = "";

  presentDateTime: any;
  reportInstanceDetailsData: any = [];

  upcomingArray: any = [];
  date:any;
  startDatetemp: any = moment.utc()
  endDateTemp: any = moment.utc()
  FormValid
  dnsId:any;
  todayDate:Date = new Date();
  fromDate=this.convertLocalDateToUTC(this.todayDate);
  endDate:Date=new Date();
  toDate:Date= this.convertLocalDateToUTC(this.endDate);
  currentDate:Date = this.convertLocalDateToUTC(this.todayDate);
  constructor(
    private constants: constants,
    private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService,
    private msg: Messages,
    private validation: validationmethod,
    private router: Router,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private reportlinksserviceService:ReportlinksserviceService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar
  ) {

    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: UploadToVault,
      commonDownloadLink:CommonDownloadLinkFromS3
    }
    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;

    this.presentDateTime = moment().format(this.msg.DATEWITHTIMEFORMATFORCONVERSION);
    console.log(`upcoming screen present date : ${this.presentDateTime}`)
  }

  ngOnInit() {
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
     this.dnsId = this.localStorageSettings.getSettings("dnsName");
    this.formvalidations()
    this.columnDefs = [
      // },
      // {
      //   headerName: 'Instance ID',
      //   headerTooltip: 'Instance ID',
      //   tooltipValueGetter: (params) => 'Instance ID: ' + params.value,
      //   field: 'instanceid',
      //   filter: 'agTextColumnFilter',
      //   width: 140
      // },
      // {
      //   headerName: 'Instance Detail ID',
      //   headerTooltip: 'Instance Detail ID',
      //   tooltipValueGetter: (params) => 'Instance Detail ID: ' + params.value,
      //   field: 'instancedetailid',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      {
        headerName: 'Template Name',
        headerTooltip: 'Template Name',
        tooltipValueGetter: (params) => 'Template Name: ' + params.value,
        field: 'templateName',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Report Name',
        headerTooltip: 'Report Name',
        tooltipValueGetter: (params) => 'Report Name : ' + params.value,
        field: 'reportName',
        filter: 'agTextColumnFilter',
        width: 210
      },
      {
        headerName: 'Scheduled Date & Time',
        headerTooltip: 'Scheduled Date & Time',
        tooltipValueGetter: (params) => 'Scheduled Date & Time : ' + params.value,
        field: 'nextScheduleDate',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Schedule Type',
        headerTooltip: 'Schedule Type',
        tooltipValueGetter: (params) => 'Schedule Type : ' + params.value,
        field: 'scheduleType',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Report Status',
        headerTooltip: 'Report Status',
        tooltipValueGetter: (params) => 'Report Status : ' + params.value,
        field: 'reportStatus',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'createdBy',
        headerTooltip: 'createdBy',
        tooltipValueGetter: (params) => 'createdBy : ' + params.value,
        field: 'createdBy',
        filter: 'agTextColumnFilter',
        width: 180
      },
      // {
      //   headerName: 'Status',
      //   headerTooltip: 'Status',
      //   tooltipValueGetter: (params) => 'Status : ' + params.value,
      //   field: 'status',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      // {
      //   headerName: 'Download Report',
      //   headerTooltip: 'Download Report',
      //   tooltipValueGetter: (params) => 'Download Report : ' + params.value,
      //   field: 'reportpath',
      //   filter: 'agTextColumnFilter',
      //   width: 180
      // },
      // {
      //   headerName: 'Report Reference',
      //   headerTooltip: 'Report Reference',
      //   cellRenderer: "commonDownloadLink",
      //   field: 'reportpath',
      //   filter: 'agTextColumnFilter',
      //   width: 180
      // }
    ]

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.date = "today";

    console.log(this.date);
  }
  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      date: new UntypedFormControl(''),
      startDate: new UntypedFormControl('', [Validators.required]),
      endDate: new UntypedFormControl('', [Validators.required]),
    })
  }

  sentToVault(e){
    console.log(e.rowData.instanceId)
    let dialogRef = this.dialog.open(SenttovaultcomponentComponent, {
      width: "70%",
      autoFocus: false,
      data: { instancedetailid: e.rowData.instancedetailid }
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);

    });
  }


  downloadcsv(e){
    console.log(e)
  }

  redirectQuickSight(e){
    console.log(e)
    console.log(e.rowData.analysisReference)
    // if(e.rowData.analysisReference === "" || e.rowData.analysisReference === null){
    //   this.snackbar.open("No Analysis Report", "OK", {
    //     duration: 5000,
    //   });
    // }else{
      // this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
      // this.router.navigate(["/user/Menubar/quickSight"],{queryParams:{anaylsis:e.rowData.analysisReference,data:JSON.stringify(e.rowData)},skipLocationChange: true,replaceUrl:false}));
               this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
       this.router.navigate(["/user/Menubar/quickSight"]));
    //}
  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridAPI.setGridOption('rowData', []);

    var startDate = moment.utc(this.startDatetemp).format('YYYY-MM-DD');
    var endDate = moment.utc(this.endDateTemp).format('YYYY-MM-DD');

     this.scheduleNextReport(startDate,endDate,this.dnsId);
     params.api.sizeColumnsToFit();

  }

  private downloadReportReference() {

  }

  scheduleNextReport(startDate,endDate,dnsId){
    this.spinner.start()
  this.reportlinksserviceService.scheduleNextReport(startDate,endDate,dnsId).subscribe((response) => {

    if (response.error == true) {

      this.spinner.stop();

      this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });

    }
    else {
      this.gridAPI.setGridOption('rowData', response);
      this.spinner.stop();


    }
  console.log(this.reportInstanceDetailsData)
  console.log(response)
  });
}



  ChangeSelect(event) {
    var getyear = moment().format("YYYY");
    var getmonth = moment().format("MM");
    if (event.value == "today") {
      this.endDateTemp = moment.utc()
      this.startDatetemp = moment.utc()
    } else if (event.value == "currentWeek") {
      this.endDateTemp = moment.utc().endOf('week')
      this.startDatetemp = moment.utc().startOf("isoWeek");
    } else if (event.value == "currentMonth") {
      this.endDateTemp = moment.utc().endOf('month')
      this.startDatetemp = moment.utc(getyear + "-" + getmonth, "YYYY-M").startOf("month");
    }
    if (this.date !=null){

    }


    this.scheduleNextReport(this.startDatetemp,this.endDateTemp,this.dnsId);
  }

  senddata(startDate,endDate) {
      this.scheduleNextReport(startDate, endDate,this.dnsId);

  }

  clearData() {
    this.endDateTemp = moment.utc(null)
    this.startDatetemp = moment.utc(null)
    this.date = null
    this.gridAPI.setGridOption('rowData', [])
    this.FormValid.reset()
  }

  collectDates(){
    if(!this.fromDate){
      this.snackBar.open(this.constants.selectFromDate, "OK", {duration: 5000});
    }
    else if (!this.toDate) {
      this.snackBar.open(this.constants.selectToDate, "OK", {duration: 5000});
    }
    else if(this.fromDate>this.toDate){
      this.snackBar.open(this.constants.toDateShouldBeGreator, "OK", {duration: 5000});
    }
    else{
    const formattedFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    const formattedToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    console.log(formattedFromDate,formattedToDate);
  this.senddata(formattedFromDate,formattedToDate);
  }


}
convertLocalDateToUTC(localDate: Date): Date {
  const utcDate = new Date(
    localDate.getUTCFullYear(),
    localDate.getUTCMonth(),
    localDate.getUTCDate(),
    localDate.getUTCHours(),
    localDate.getUTCMinutes(),
    localDate.getUTCSeconds()
  );
  return utcDate;
}
}
